/* eslint-disable no-param-reassign */

const state = {
  itsLoading: false,
};

const getters = {
  itsLoading: currentState => currentState.itsLoading,
};

const actions = {
  startLoading({ commit }) {
    commit('setLoading', true);
  },
  stopLoading({ commit }) {
    commit('setLoading', false);
  },
};

const mutations = {
  setLoading: (currentState, itsLoading) => {
    currentState.itsLoading = itsLoading;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
